export function ADD_BRANCH(body = {}) {
    return {
        type: "ADD_BRANCH",
        body
    };
};

export function UPDATE_BRANCH(body = {}){
    return {
        type: "UPDATE_BRANCH",
        body
    }
}

export function REMOVE_BRANCH(body = {}){
    return {
        type: "REMOVE_BRANCH",
        body
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/branch.js